.places .place .bar {
  min-height: 46px;
  line-height: 46px;
  border-radius: 4px;
  padding-left: 20px;
  margin-top: 4px;
}
.places .place .title {
  background-color: rgb(3.3333333333%, 16.6666666667%, 13.3333333333%);
  color: #aaeedd;
  cursor: pointer;
  user-select: none;
}
.places .place .title .name {
  margin-left: 12px;
}
.places .place .add {
  display: block;
  background-color: var(--plus-color-back);
}
.places .place .add .name {
  margin-right: 8px;
}
.places .place .add .icon {
  color: var(--plus-color-icon);
}
.places .place .add.selected {
  background-color: var(--plus-color-selected);
}
.places .place .edit {
  display: inline-block;
  width: 32px;
  height: 32px;
  line-height: 32px;
  margin-top: 7px;
  text-align: center;
  margin-right: 8px;
  background-color: #aaeedd;
  color: rgb(3.3333333333%, 16.6666666667%, 13.3333333333%);
  border-radius: 4px;
  float: right;
  cursor: pointer;
}
.places .place .delete {
  background-color: #f8d7da;
  color: #842029;
}
.places .place .panel {
  padding: 4px 0 8px 20px;
}
.places .place .panel .tabs {
  display: flex;
  gap: 8px;
  margin: 4px 0;
}
.places .place .panel .tab {
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 0.85rem;
  opacity: 0.7;
  cursor: pointer;
  user-select: none;
}
.places .place .panel .tabActive {
  opacity: 1;
  background-color: #aaeedd;
  color: rgb(3.3333333333%, 16.6666666667%, 13.3333333333%);
}
.places .place .order {
  padding: 0 0 8px 0;
}
.places .place .order .orderTitle {
  font-size: 0.85rem;
  opacity: 0.7;
  margin: 4px 0;
}
.places .place .order .orderRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: var(--clickable-height);
  padding: 2px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.25);
  background-color: transparent;
}
.places .place .order .orderRow .orderName {
  flex: 1;
}
.places .place .order .orderRow .handle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  margin-right: 12px;
  align-self: stretch;
  border-radius: 4px;
  color: rgb(3.3333333333%, 16.6666666667%, 13.3333333333%);
  background-color: #aaeedd;
  cursor: grab;
  touch-action: none;
}
.places .place .order .orderRow .visibility {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  align-self: stretch;
  border-radius: 4px;
  cursor: pointer;
}
.places .place .order .hidden .orderName {
  opacity: 0.4;
  text-decoration: line-through;
}
.places .place .order .dragging {
  position: relative;
  z-index: 10;
  background-color: #aaeedd;
  color: rgb(3.3333333333%, 16.6666666667%, 13.3333333333%);
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.3);
}
.places .place .order .dragging .handle {
  cursor: grabbing;
}

:global(.dark) .places .place .order {
  color: #c4d4d0;
}
:global(.dark) .places .place .order .orderRow {
  border-bottom-color: rgba(255, 255, 255, 0.18);
}
:global(.dark) .places .place .add {
  color: #d8e8d8;
}
:global(.dark) .places .place .panel {
  color: #c4d4d0;
}
:global(.dark) .places .place .panel .tabActive {
  background-color: #223431;
  color: #eafff8;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */